import React, { useState } from 'react'
import { useMutation, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../hooks/hooks';
import { useGetTeachersQuery } from '../../hooks/useGetTeachersQuery';
import { routes } from '../../routes';
import toast from 'react-hot-toast';
import { updateTeacher } from '../../services/school/teacher/updateTeacher';
import { Key_teachers, PAGE_NUMBER, PAGE_SIZE } from '../../utils/constants';
import { CreateTeacherType, TeacherType } from '../../types/Teacher';
import { getUserById } from '../../services/user/getUsers';
import { setTeacherData, setUpdateTeacherData } from '../../redux/slices/school/teacher';
import { Pencil1Icon, SewingPinFilledIcon, TrashIcon } from '@radix-ui/react-icons';
import { Lists } from '../../components/common/Lists';
import TableComponent from '../../components/common/Tables';
import { getTeacherRequiredDocuments } from '../../services/school/teacher/getTeacherRequiredDocuments';
import { getTeacherDepartaments, getTeacherDocuments } from '../../services/school/teacher/getTeachers';
import { formatDateForInput } from '../../utils/dateFormatter';
import { syncTeacher } from '../../services/school/teacher/createTeacher';
import { Button, Flex } from '@radix-ui/themes';
import { useForm } from 'react-hook-form';
import { ConfirmAlertDialog } from '../../components/common/ConfirmAlertDialog';

const columnNamesMap: { [key: string]: string } = {
  // teacherUniversalCode: "Código",
  fullname: "Nome",
  // typeContract :"Tipo contrato",
  // category :"Categoria",
  lastDateSynced: "Última sincronização com Esura Central",
  isOkAnualSync :"Estado de sincronização anual",
};
export const Teachers = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const [syncSelected, setSyncSelected] = useState<any[] | null>(null);
  const mutation = useMutation(syncTeacher, {
    onSuccess: () => {
      toast.success("Pedido de sincronizar enviado ao Esura Central!");
    },
    onError: () => {
      toast.error("Erro ao sincronizar docente.");
    }
  });
  const { data, status } = useGetTeachersQuery({ PageNumber: currentPage, PageSize: pageSize, SearchTerm: searchTerm });
  const mutationDelete = useMutation(updateTeacher, {
    onSuccess: () => {
      queryClient.invalidateQueries(Key_teachers);
      toast.success('Apagado');
    },
    onError: () => {
      toast.error("Erro ao apagar.")
    }
  });
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };
  const handlePageSizeChange = (size: number) => {
    setPageSize(size);
    setCurrentPage(PAGE_NUMBER);
  };

  const handleSearch = (term: string) => {
    setSearchTerm(term);
    setCurrentPage(1);
  };
  const handleClickCreate = (event: any): void => {
    navigate(routes.createTeacher)
  }
  const handleEdit = async (teacher: TeacherType) => {
    try {
      if (!teacher.idUser) return;
      const userData = await getUserById(teacher.idUser)
      const { items: itemsDocuments } = await getTeacherDocuments({ PageNumber: 1, PageSize: 100, IdTeacher: teacher.id })
      const { items: itemsDepartaments } = await getTeacherDepartaments({ PageNumber: 1, PageSize: 100, IdTeacher: teacher.id })

      const teacherForm: CreateTeacherType = {
        user: { ...userData, isForeign: teacher?.isForeign ?? false },
        teacher: {
          ...teacher,
          id: teacher.id,
          status: teacher.status,
          enrollmentDate: formatDateForInput(teacher.enrollmentDate!),
          teacherUniversalCode: teacher.teacherUniversalCode,
          endDate: teacher.endDate,
          idUser: teacher.idUser,
          idTeacherSupervisor: teacher.idTeacherSupervisor,
          idDepartament: "", 
          isLinked: teacher.isLinked??true,
          lastDateSynced: teacher.lastDateSynced,
        },
        documents: [],
        storeDocuments: itemsDocuments,
        teacherDepartaments: itemsDepartaments
      }
      dispatch(setUpdateTeacherData(teacherForm));
      navigate(routes.updateTeacher);
    } catch (error) {

    }
  }

  const handleDepartaments = async (teacher: TeacherType) => {

    navigate(routes.updateTeacher);
  }
  const handleClickEvaluations = async (teacher: TeacherType) => {
    dispatch(setTeacherData(teacher));
    navigate(routes.teacherEvaluations);
  }
  const handleClickTeacherEvaluate = async (teacher: TeacherType) => {
    dispatch(setTeacherData(teacher));
    navigate(routes.evaluateTeacher);
  }

  const handleDelete = (teacher: TeacherType) => {
    try {

      mutationDelete.mutateAsync(teacher)
    } catch (error: any) {
      toast.error(`${mutationDelete.error ?? error?.message}`);

    }
  };
  const options = data?.items.map(() => [
    {
      label: 'Editar',
      onClick: (teacher: any) => handleEdit(teacher),
      icon: <Pencil1Icon />
    },
    {
      label: 'Avaliar docente',
      onClick: (teacher: any) => handleClickTeacherEvaluate(teacher),
      icon: <Pencil1Icon />
    },
    {
      label: 'Avaliaçóes',
      onClick: (teacher: any) => handleClickEvaluations(teacher),
      icon: <Pencil1Icon />
    },
    {
      label: 'Excluir',
      onClick: (teacher: any) => handleDelete(teacher),
      icon: <TrashIcon />
    }
  ]) || [];
  const handleOnClickSyncAll = async (event: any) => {
    event.preventDefault();
    const submitData = {
      isSyncAll: true,
      total: data?.totalItems,
    }
    try {
      await mutation.mutateAsync(submitData);

    } catch (error) {
      toast.error("Erro ao sincronizar todos os estudantes");
    }
  }
  const openSyncSelectedDialog = async (c: any[]) => {
    setSyncSelected(c);
  };
  const optionsForMassiveItems = [
    {
      label: 'Sincronizar selecionados',
      onClick: openSyncSelectedDialog,
      icon: <SewingPinFilledIcon />
    },
  ];
  const confirmSyncSelected = async () => {
    try {
      if (!syncSelected) return;
      const submitData = {
        isSyncAll: false,
        total: syncSelected.length,
        teachersIds: syncSelected.map((s) => s.id)
      }
      await mutation.mutateAsync(submitData);
    } catch (error) {
      toast.error("Erro ao sincronizar selecionados");
    }
  };
  const { control, handleSubmit, formState: { errors }, getValues, setValue, trigger, watch, reset, resetField } = useForm({
    defaultValues: {},
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldUseNativeValidation: false,
  });

  return (
    <Flex gap="4" direction="column">
      <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
        <Button onClick={handleOnClickSyncAll} variant='surface'
        >
          Sincronizar todos com Esura Central
        </Button>
      </Flex>
      <Lists
        status={status}
        TableComponent={() =>
          <TableComponent
            columns={Object.keys(columnNamesMap)}
            items={data?.items.map(i=>({ ...i, 
              isOkAnualSync:  i?.lastDateSynced && new Date(i?.lastDateSynced).getFullYear() ===new Date().getFullYear() ? "Conforme" : "Não conforme" })) || []}
            options={options}
            columnNamesMap={columnNamesMap}
            totalPages={data?.totalPages || 1}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            pageSize={pageSize}
            onPageSizeChange={handlePageSizeChange}
            onSearch={handleSearch}
            search={searchTerm}
            totalItems={data?.totalItems || 0}
            getValues={getValues}
            setValue={setValue}
            control={control}
            optionsForMassiveItems={optionsForMassiveItems}
          />
        }
        handleClickCreate={handleClickCreate}
      />
      <ConfirmAlertDialog
        open={!!syncSelected}
        onOpenChange={(open) => !open && setSyncSelected(null)}
        title="Esta operação é irreversível"
        item={syncSelected}
        onConfirm={confirmSyncSelected}
        onCancel={() => setSyncSelected(null)} />
    </Flex>
  );
}
